import { render } from "./ArrowRightIcon.vue?vue&type=template&id=7a4ebb63&scoped=true"
const script = {}

import "./ArrowRightIcon.vue?vue&type=style&index=0&id=7a4ebb63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4ebb63"]])

export default __exports__